import { PrepJobResponse } from "@deliverr/prep-service-client";
import { createActionCreator } from "common/ReduxUtils";
import { PrepActionTypes } from "prep/store/PrepActionTypes";

/**
 * @param prepJob the current PrepJob
 */
export const setPrepJob = createActionCreator<PrepJobResponse | undefined>(PrepActionTypes.SET_PREP_JOB, "prepJob");
